module.exports = __webpack_public_path__ + "img/travel_5.cb927a42.svg";